<div [ngStyle]="getStyle()" class="sticky">
  <app-block-list [blockIdList]="body"></app-block-list>
</div>
